import historyUtils from '../utils/utils-routing';
import * as types from '../../store/constants';
import { getPaginationStateObject } from './Pagination';

export function getGroupByStateObject(encode = false) {
    return {
        name: 'groupBy',
        value: undefined,
        encode
    };
}

export function replaceURLGroupByEntry(groupBy: { readonly key: string; readonly label?: string }) {
    const isProducts = groupBy.key === types.GROUPBY_PRODUCTS;

    const pageQueryState = getPaginationStateObject();
    const groupByQueryState = getGroupByStateObject(!isProducts);

    if (!isProducts) {
        // FIXME: it should be sufficient to use the `key` as query param value instead of thw whole object
        groupByQueryState.value = groupBy as any;
    }
    historyUtils.replaceURLSearchStates([pageQueryState, groupByQueryState]);
}

export function deleteURLGroupByEntry() {
    const pageQueryState = getPaginationStateObject();
    const groupByQueryState = getGroupByStateObject();
    historyUtils.replaceURLSearchStates([pageQueryState, groupByQueryState]);
}
